import type { StandardViewKey } from '@platform/core/types';

/** Подання переліку «Подання записів» конструктора в порядку прототипу v4 (VIEWS після unshift/push). */
export const builderViewKeys: readonly string[] = ['overview', 'advisory', 'library', 'dashboard', 'table', 'stages', 'cards', 'inline', 'backlog', 'split', 'byarea', 'traces', 'tmatrix', 'byteam', 'calendar'];

/** Стандартні подання рушія (`views.enabled`), порядок — як у переліку конструктора. */
export const standardViewKeys: readonly StandardViewKey[] = ['dashboard', 'table', 'stages', 'cards', 'inline', 'backlog', 'split', 'calendar'];

/** Сторінки модуля, які прототип показує серед подань (огляд і поради): не належать типу запису, тож у конструкторі не перемикаються. */
export const pageViewKeys: readonly string[] = ['overview', 'advisory'];
